export class Profession {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor(){}
}

export class ProfessionForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;
    
    constructor(){}
}